<template>
  <input-base
    :overlap="overlap"
    :small="small"
    :transparent="transparent"
    :stretched="stretched"
    :slimmer="slimmer">

    <label
      v-if="!noLabel"
      slot="label">

      <q-icon
        :allowSelfUpdate="false"
        class="label-icon d-box d-md-none"
        width="11.5px"
        name="calendar" />

      <label
        v-if="!!inputLabel"
        :for="inputName">

        {{ inputLabel }}
      </label>
    </label>

    <div
      class="icon-input"
      slot="input">

      <time-picker
        :class="getInnerStyle"
        :name="inputName"
        v-model="time"
        format="hh:mm A" />

    </div>
  </input-base>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import '@/components/standard/input/vue-datetime/dist/vue-datetime.css'

import InputBase from '@/components/standard/input/InputBase'
import stylers from '@/mixins/components/standard/input/inputButton/stylers'
import '@/assets/styles/standardInputs.css'
import configurations from '@/assets/configurations/configurations'
import QIcon from '@/components/standard/display/QIcon'

export default {
  data () {
    return {
      timeFormat: configurations.dateTimePickerFormat,
      time: this.getBaseValue()
    }
  },

  methods: {
    /**
     * Gives default value
     * @returns {Object}
     */
    getBaseValue () {
      let base = {
        hh: this.inputValue.hh,
        mm: this.inputValue.mm,
        A: this.inputValue.A
      }

      return base
    }
  },

  computed: {
    /**
     * Gives input's value
     * @returns {Object}
     */
    getInputValue () {
      return this.time
    }
  },

  props: {
    inputValue: {
      type: Object,
      required: false,
      default: () => {return {
        hh: "0",
        mm: "00",
        A: "AM"
      }}
    }
  },

  watch: {
    time: {
      handler: function () {
        this.$emit('fieldUpdate', {
          value: this.time,
          input: this.inputName,
          extra: this.sideValue
        })
      },
      deep: true
    }
  },

  components: {
    'q-icon': QIcon,
    'input-base': InputBase,
    'time-picker': VueTimepicker
  },
  mixins: [
    stylers
  ]
}
</script>

<style scoped>
.label-icon {
  top: -1px;
  position: relative;
}

.dtime-icon {
  position: absolute;
  margin-top: 15px;
  margin-left: 18px;
}
.vdatetime-input {
  width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  padding-left: 31px;
}

.dt-picker {
  border: 1px solid rgb(194, 194, 194);
  padding: 5px 15px;
}
.rounded {
  border-radius: 10px;
}

.p-holder {
  position: absolute;
  margin-top: auto;
  font-size: 14px;
  transition: margin-top .3s, font-size .3s;
}
.above {
  margin-top: -15px;
  font-size: 10px;
}
.smaller {
  padding: 5px 15px!important;
}
.small {
  padding: 2px 15px!important;
}
.time-icon.adjust-small {
  margin-top: 4px;
}

@media (max-width: 768px) {
  .vdatetime-input {
    padding-left: 0;
    width: 168px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/standard/input/InputTime.vue?dda9d8ca